module.exports = __webpack_public_path__ + "img/img0.543e715f.jpg";